import React, { useEffect, useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { useLocation } from '@reach/router';
import { Link } from 'gatsby-theme-material-ui';
import { MenuItemsSet, arrLinks, settings } from '../Navbar/Navbar';
import { styles } from './styles';
import { styles as navbarStyles } from '../Navbar/styles';
import { ChevronUpIcon } from '../icons/ChevronUpIcon';

export default function BurgerMenu({ lkButtons }) {
  const { pathname } = useLocation();
  const [burgerMenuIsOpen, setBurgerMenuIsOpen] = useState(false);
  const [isProgramsOpen, setIsProgramsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setBurgerMenuIsOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setBurgerMenuIsOpen(false);
  };

  const handleProgramsClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsProgramsOpen((prev) => !prev);
  };

  useEffect(() => {
    window?.addEventListener('scroll', handleClose);
    return () => {
      window?.removeEventListener('scroll', handleClose);
    };
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <Box onClick={handleClick} sx={styles.burgerMenu(burgerMenuIsOpen)} />

      <Menu
        disableScrollLock
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        onClick={handleClose}
        anchorReference="anchorEl"
        keepMounted
        disableAutoFocusItem
        sx={{
          '.MuiMenu-paper': {
            maxWidth: 'none',
            width: '100%',
            top: '48px !important',
            left: '0 !important',
            right: '0 !important',
          },
        }}
      >
        {arrLinks.map((link) => {
          const href = link.extraHref ? link.extraHref[1] : link.href;
          if (link.isButton) {
            return (
              <Box key={link.href} sx={{ mb: isProgramsOpen ? 3.5 : 0 }}>
                <Link
                  onClick={handleProgramsClick}
                  variant="desktopP3"
                  underline="none"
                  sx={styles.link}
                >
                  <Box sx={{ display: 'flex', cursor: 'pointer' }}>
                    <Box sx={{ ...navbarStyles.programTitle, mb: 1 }}>
                      <Typography color={'kit.text.h'}>Программы</Typography>
                    </Box>
                    <ChevronUpIcon
                      color="kit.text.h"
                      sx={navbarStyles.chevronIcon(isProgramsOpen)}
                    />
                  </Box>
                </Link>
                {isProgramsOpen &&
                  settings.map((settingsSet, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                      }}
                    >
                      <Typography
                        variant="desktopP2"
                        sx={{
                          color: 'kit.text.secondary',
                          marginTop: index === 0 ? '0' : '6px',
                        }}
                      >
                        {index === 0
                          ? 'Основные программы'
                          : index === 1
                            ? 'Подготовительные программы'
                            : 'Повышение квалификации'}
                      </Typography>
                      <MenuItemsSet
                        index={index}
                        settings={settingsSet}
                        activePath={pathname}
                        cbCloseMenu={() => {
                          setBurgerMenuIsOpen(false);
                          setAnchorEl(null);
                        }}
                      />
                    </Box>
                  ))}
              </Box>
            );
          }
          return (
            <MenuItem key={link.title}>
              <Link
                href={href}
                sx={{
                  ':hover': {
                    textDecoration: 'none',
                  },
                }}
                variant="kitSecondary"
                underline="none"
              >
                {link.title}
              </Link>
            </MenuItem>
          );
        })}
        <MenuItem>
          <Box display={'flex'} gap={2}>
            {lkButtons}
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
}
